<template>
    <div>
        <spinner v-if="cargando"></spinner>
        <section class="container">
            <div class="row">
                <div class="kt-portlet col-md-8 col-12 order-2 order-md-1">
                    <div class="alert alert-primary text-center" v-if="listo" v-html="texto"></div>
                    <div v-else >
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">
                                    Ingrese sus datos en el siguiente formulario
                                </h3>
                            </div>
                        </div>
                        <form class="kt-form"  @submit.prevent="validar" data-vv-scope="form-1" >
                            <div class="kt-portlet__body">
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                        <i class="fa fa-asterisk text-danger"></i>
                                        Cédula de identidad
                                    </label>
                                    <div class="col-md-9 col-sm-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Número"
                                                name="cédula"
                                                id="cédula"
                                                autoFocus
                                                v-validate="{required:true,ci:true,length:10,numeric:true}"
                                                v-model="formulario.ci"
                                        />
                                        <span class="form-text text-danger">{{ errors.first('form-1.cédula') }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                        <i class="fa fa-asterisk text-danger"></i>
                                        Nombres
                                    </label>
                                    <div class="col-md-9 col-sm-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Nombres"
                                                name="nombres"
                                                v-validate="{required:true,alpha_spaces:true,max:50}"
                                                v-model="formulario.nombres"
                                        />
                                        <span class="form-text text-danger">{{ errors.first('form-1.nombres') }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                        <i class="fa fa-asterisk text-danger"></i>
                                        Apellidos
                                    </label>
                                    <div class="col-md-9 col-sm-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Apellidos"
                                                name="apellidos"
                                                v-validate="{required:true,alpha_spaces:true,max:50}"
                                                v-model="formulario.apellidos"
                                        />
                                        <span class="form-text text-danger">{{ errors.first('form-1.apellidos') }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                        <i class="fa fa-asterisk text-danger"></i>
                                        Email
                                    </label>
                                    <div class="col-md-9 col-sm-12">
                                        <input
                                                type="email"
                                                class="form-control"
                                                placeholder="sample@sample.com"
                                                name="email"
                                                v-validate="{required:true,email:true,max:50}"
                                                v-model="formulario.email"
                                        />
                                        <span class="form-text text-danger">{{ errors.first('form-1.email') }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                        <i class="fa fa-asterisk text-danger"></i>
                                        Teléfono Celular
                                    </label>
                                    <div class="col-md-9 col-sm-12">
                                        <input
                                                type="tel"
                                                class="form-control"
                                                placeholder="0998877665"
                                                name="celular"
                                                v-validate="{required:true,...valTelf.celular}"
                                                v-model="formulario.telefono"
                                        />
                                        <span class="form-text text-danger">{{ errors.first('form-1.celular') }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                        <i class="fa fa-asterisk text-danger"></i>
                                        Paquete
                                    </label>
                                    <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                        <span class="kt-widget13__text kt-widget13__text--bold">{{pasosAn[2].paquete.dt2}}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                        <i class="fa fa-asterisk text-danger"></i>
                                        Concesionario
                                    </label>
                                    <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                        <span class="kt-widget13__text kt-widget13__text--bold">{{pasosAn[3].agencia.canton+" " +pasosAn[3].agencia.empresa+" "+pasosAn[3].agencia.nombre}}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 col-sm-12 col-form-label">
                                    </label>
                                    <div class="col-md-9 col-sm-12">
                                        <label class="kt-checkbox kt-checkbox--tick kt-checkbox--brand">
                                            <input type="checkbox" v-model="formulario.promo"> {{msgEmail}}
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="kt-portlet__foot ">
                                <div class="kt-form__actions">
                                    <div class="row">
                                        <div class="col-12 col-md-4 p-1">
                                            <button
                                                    type="submit"
                                                    :disabled="!formulario.promo"
                                                    class="btn btn-block btn-outline-brand btn-md btn-tall btn-wide kt-font-bold "
                                            >
                                                Solicitar cotización
                                            </button>
                                        </div>
                                        <div class="col-12 col-md-4 p-1">
                                            <button
                                                    type="button"
                                                    class="btn btn-block btn-secondary btn-md btn-tall btn-wide kt-font-bold"
                                                    v-on:click="cancelar"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                        <div class="col-12 col-md-4 p-1" v-if="mstOnline">
                                            <button
                                                    type="button"
                                                    :disabled="!formulario.promo"
                                                    class="btn btn-block btn-brand btn-md btn-tall btn-wide kt-font-bold"
                                                    v-on:click="ventaOnline"

                                            >
                                                Compra en linea
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-md-4 col-12 row order-1 order-md-2">
                    <resumen></resumen>
                </div>
            </div>
            <b-modal v-model="modal" hide-footer size="lg" title="Registro de Usuario">
                <form class="kt-form p-5" @submit.prevent="validar2" data-vv-scope="form-2">
                    <div class="kt-portlet__body">
                        <div class="form-group row">
                            <label class="col-md-3 col-sm-12 col-form-label">
                                Cédula de Identidad
                            </label>
                            <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                <span class="kt-widget13__text kt-widget13__text--bold">{{formulario.ci}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-sm-12 col-form-label">
                                Nombres
                            </label>
                            <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                <span class="kt-widget13__text kt-widget13__text--bold">{{formulario.nombres}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-sm-12 col-form-label">
                                Apellidos
                            </label>
                            <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                <span class="kt-widget13__text kt-widget13__text--bold">{{formulario.apellidos}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-sm-12 col-form-label">
                                Email
                            </label>
                            <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                <span class="kt-widget13__text kt-widget13__text--bold">{{formulario.email}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-sm-12 col-form-label">
                                Teléfono celular
                            </label>
                            <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                <span class="kt-widget13__text kt-widget13__text--bold">{{formulario.telefono}}</span>
                            </div>
                        </div>
                        <input type="hidden" name="username" :value="formulario.email">
                        <div class="form-group row">
                            <label class="col-md-3 col-sm-12 col-form-label">
                                <i class="fa fa-asterisk text-danger"></i>
                                Ingrese una contraseña
                            </label>
                            <div class="col-md-9 col-sm-12">
                                <input
                                        type="password"
                                        class="form-control"
                                        :class="errors.has('form-2.contraseña') && 'is-invalid'"
                                        name="contraseña"
                                        v-validate="{required:true,max:10,min:7}"
                                        v-model="formulario.password"
                                        ref="contraseña"
                                />
                                <span class="form-text text-danger">{{ errors.first('form-2.contraseña') }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-sm-12 col-form-label">
                                <i class="fa fa-asterisk text-danger"></i>
                                Confirmar contraseña
                            </label>
                            <div class="col-md-9 col-sm-12">
                                <input
                                        type="password"
                                        class="form-control"
                                        :class="errors.has('form-2.confirmar contraseña') && 'is-invalid'"
                                        name="confirmar contraseña"
                                        v-validate="{required:true,confirmed:'contraseña'}"
                                        data-vv-as="contraseña"
                                />
                                <span class="form-text text-danger">{{ errors.first('form-2.confirmar contraseña') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="kt-portlet__foot ">
                        <div class="kt-form__actions">
                            <button
                                    type="button"
                                    v-on:click="validar2"
                                    class="btn btn-brand btn-block btn-md btn-tall btn-wide kt-font-bold"
                            >
                                Registrar usuario
                            </button>
                        </div>
                    </div>
                </form>
            </b-modal>
        </section>
    </div>
</template>

<script>
    import constantes from "../../constantes";
    import spinner from "../../componentes/spinner";
    import {formulario, auth} from "../../servicios";
    import _ from 'lodash';
    import resumen from "../Paso3/resumen-vertical";
    export default {
        name: "formulario",
        data:()=>({
            formulario:{
                ci:null,
                nombres:null,
                apellidos:null,
                telefono:null,
                email:null,
                token:null,
                tipo:constantes.Constantes.enumeraciones.campana.personalizado,
                fecha:null,
                genero:{id:null},
                promo:false,
                online:false,
                password:null,
            },
            valTelf:constantes.Constantes.validacion,
            cargando:false,
            listo:false,
            texto:constantes.Constantes.formularioCompleto,
            modal:false,
            msgEmail:constantes.Constantes.emails
        }),
        components:{
            spinner,
            resumen
        },
        computed:{
            pasosAn:function(){
                return this.$store.getters.getPasos;
            },
            mstOnline:function(){
                return process.env.VUE_APP_ONLINE === 'true';
            }
        },
        methods:{
            validar:function(){
                this.$validator.validateAll('form-1').then((result) => {
                    if (result) {
                        this.cargando=true;
                        this.enviarConcecionario();
                    } else {
                        this.$toast.show(`Completa el formulario`);
                    }
                });
            },
            enviarConcecionario:_.debounce(function(){
                this.$recaptcha('formulario').then((token) => {
                    this.formulario.token = token;
                    this.formulario.tipo = constantes.Constantes.enumeraciones.campana.personalizado;
                    formulario.interesadoV2(this.formulario,this.$store.getters.getPasos).then(()=>{
                        this.cargando=false;
                        this.listo=true;
                        this.$analytics.fbq.event('track','CompleteRegistration');
                        setTimeout(()=>{
                            this.$store.commit('limpiar', null);
                            this.$store.commit('setActual', null);
                            this.$store.commit('setSubActual',0);
                            this.$router.push({ name: 'gracias' });
                        },3000);

                        event({
                            category: 'Registro',
                            action: this.$store.getters.getPasos[1].modelo.dt1,
                            label: this.$store.getters.getPasos[2].paquete.dt2
                        });

                    }).catch(()=>{
                        this.cargando=false;
                    })
                });
            },2000),
            envioEnlinea:_.debounce(function(){
                    auth.validarDatos(this.formulario).then(()=>{
                        auth.register(this.formulario).then(r=>r.data).then(response=>{
                            this.$recaptcha('formularioOnline').then((token) => {
                                this.formulario.token = token;
                                this.formulario.online = true;
                                this.formulario.tipo = constantes.Constantes.enumeraciones.campana.online;
                                formulario.interesado(this.formulario, this.$store.getters.getPasos).then(()=>{
                                    this.validacionSMS(response);
                                });
                            });
                        }).catch(()=>{
                            this.cargando=false;
                            this.modal=true;
                            this.formulario.password=null;
                        });
                    }).catch(()=>{
                        this.cargando=false;
                        this.modal=true;
                        this.formulario.password=null;
                    });

            },2000),
            validacionSMS:function(registro){
                this.cargando=false;
                this.modal=false;
                this.$swal({
                    title: "Validación de Usuario",
                    html: '<b>Un código de verificación único (OTP) ha sido enviado a su teléfono '+this.formulario.telefono+' como SMS y a su dirección de correo electrónico. Para verificar su cuenta de usuario, por favor ingrese el código a continuación.</b>',
                    input: 'text',
                    inputAttributes: {
                      autocapitalize: 'off'
                    },
                    inputValidator: (value) => {
                      if (!value || value.length !== constantes.Constantes.lengthOTP) {
                        return 'Necesita ingresar un código OTP enviado a su Celular y a su Email'
                      }
                    },
                    showLoaderOnConfirm: true,
                    showCancelButton: true,
                    confirmButtonText: 'Verificar',
                    confirmButtonAriaLabel: 'Verificar',
                    cancelButtonText: 'Reenviar OTP',
                    cancelButtonAriaLabel: 'Reenviar OTP',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    preConfirm: (texto) => {
                        const dto = {
                            id:registro.id,
                            codigo:texto,
                            formulario:this.formulario
                        };
                        return this.$store.dispatch('registerU',dto).then(()=>{
                            this.listo = true;
                            this.$store.commit('limpiar', null);
                            this.$store.commit('setActual', null);
                            this.$store.commit('setSubActual', 0);
                            this.$router.push({name: 'cotizaciones'});
                            return texto;
                        }).catch(()=> {
                            this.cargando=true;
                            setTimeout(()=>{
                              this.validacionSMS(registro);
                            },500);
                            return texto;
                        });
                    },
                }).then(result=>{
                    if(result.dismiss==="cancel"){
                        this.cargando=true;
                        setTimeout(()=>{
                          this.reenviarSMS(registro);
                        },900);
                    }
                });
            },
            reenviarSMS:function(registro){
                auth.reenviarCode(registro.id).then(()=>{
                    this.cargando=false;
                    this.validacionSMS(registro);
                }).catch(()=>{
                    this.cargando=false;
                    this.validacionSMS(registro);
                })
            },
            validar2:function(){
                this.$validator.validateAll('form-2').then((result) => {
                    if (result) {
                        this.modal=false;
                        this.cargando=true;
                        this.envioEnlinea();
                    } else {
                        this.$toast.show(`Completa el formulario`);
                    }
                });
            },
            cancelar:function(){
                this.$store.commit('setActual',1);
                this.$router.push({ name: 'p1'});
            },
            ventaOnline:function(){
                this.cargando = true;
                this.$validator.validateAll('form-1').then((result) => {
                    if (result) {
                        const vm = this;
                        this.$store.commit('setPaso',{p:"4",data:this.formulario});
                        this.$swal({
                            html: `<small>Estimado Cliente, para continuar con el proceso de Compra Online, es necesario crear un Usuario con los datos ingresados en la cotización.</small><br><br><b>¿Desea Crear una Cuenta de Usuario?</b>`,
                            type: 'warning',
                            showCloseButton: true,
                            showCancelButton: true,
                            focusConfirm: true,
                            confirmButtonText: 'Si',
                            confirmButtonAriaLabel: 'No',
                            cancelButtonText: 'No',
                            cancelButtonAriaLabel: 'Si',
                        }).then(function (valor) {
                            if(valor.value){
                                vm.cargando=true;
                                setTimeout(()=>{
                                    vm.cargando=false;
                                    vm.modal=true;
                                },1000);
                            }
                        });
                    } else {
                        this.$toast.show(`Completa el formulario`);
                    }
                    this.cargando = false;
                });
            }
        },
        created() {
            if(constantes.funciones.isEmpty(this.$store.getters.getPasos))
                this.$router.push({ name: 'p1'});
            else
            if(!constantes.funciones.isEmpty(this.$store.getters.getPasos["4"]))
                this.formulario=this.$store.getters.getPasos["4"];
        }
    }
</script>

<style scoped>

</style>
